const patientStories = (() => {
    const initBlock = (el) => {
        handleToggleTag(el);
        handlePaging(el);
        getResults(el, 'all', '1');
    };

    const handleToggleTag = (el) => {
        const filters = el.querySelector('[data-patient-story-filters]');
        if (filters) {
            filters.querySelectorAll('[data-tag]').forEach(tag => {
                tag.addEventListener('click', () => {
                    getResults(el, tag.dataset.alias, '1');
                    filters.querySelectorAll('[data-tag]').forEach(tag2 => {
                        tag2.classList.add('button--2');
                        tag2.classList.remove('selected-tag');
                    });
                    tag.classList.remove('button--2');
                    tag.classList.add('selected-tag');
                });
            });
        }
    };

    const handlePaging = (el) => {
        const paging = el.querySelector('.pagination');
        const resultsWrapper = el.querySelector('[data-items]');
        const filters = el.querySelector('[data-patient-story-filters]');

        const getSelectedTagAlias = () => {
            if (filters === null || filters === undefined) {
                return "all";
            }
            const selectedTag = filters.querySelector('.selected-tag');
            return selectedTag.dataset.alias;
        }
        
        const totalPages = resultsWrapper.dataset.totalPages;
        updatePaging(el, "1", totalPages);
        if (paging && resultsWrapper         ) {
            const prev = paging.querySelector('[title="Previous Page"]');
            const next = paging.querySelector('[title="Next Page"]');
            const select = paging.querySelector('select');
            prev.addEventListener('click', () => {
                const currentPage = resultsWrapper.dataset.currentPage;
                let currentPageValue = parseInt(currentPage);
                currentPageValue--;
                resultsWrapper.dataset.currentPage = currentPageValue.toString();
                getResults(el,  getSelectedTagAlias(), currentPageValue);
            });
            next.addEventListener('click', () => {
                const currentPage = resultsWrapper.dataset.currentPage;
                let currentPageValue = parseInt(currentPage);
                currentPageValue++;
                resultsWrapper.dataset.currentPage = currentPageValue.toString();
                getResults(el,  getSelectedTagAlias(), currentPageValue);
            });

            select.addEventListener('change', () => {
                resultsWrapper.dataset.currentPage = select.value;
                getResults(el,  getSelectedTagAlias(), select.value);
            });
        }
    };

    const updatePaging = (el, currentPage, totalPages) => {
        const paging = el.querySelector('.pagination');
        const prev = paging.querySelector('[title="Previous Page"]');
        const next = paging.querySelector('[title="Next Page"]');
        const select = paging.querySelector('select');
        if (parseInt(totalPages) <= 1) {
            paging.classList.add('pagination--hidden');
        } else {
            paging.classList.remove('pagination--hidden');
            if (currentPage.toString() === "1") {
                prev.setAttribute('disabled', '');
                prev.classList.add('disabled');
            } else {
                prev.removeAttribute('disabled');
                prev.classList.remove('disabled');
            }
            if (currentPage.toString() === totalPages.toString()) {
                next.setAttribute('disabled', '');
                next.classList.add('disabled');
            } else {
                next.removeAttribute('disabled');
                next.classList.remove('disabled');
            }
            const totalPagesValue = parseInt(totalPages);
            let options = [];
            for (let i = 1; i <= totalPagesValue; i++) {
                options.push(`<option value=${i} ${parseInt(currentPage) === i ? "selected" : ""}>${i}</option>`)
            }
            select.innerHTML = options.join('');
        }
    }
    
    const getResults = (el, tag, currentPage) => {
        const resultsWrapper = el.querySelector('[data-items]');
        if (resultsWrapper) {
            const pageId = resultsWrapper.dataset.pageId;
            const pageSize = resultsWrapper.dataset.pageSize;
            fetch(`/umbraco/surface/PatientStories/Get?pageId=${pageId}&pageSize=${pageSize}&currentPage=${currentPage}&tag=${tag}`)
                .then(response => response.text())
                .then(data => {
                    resultsWrapper.outerHTML = data;
                    const resultsWrapperNew = el.querySelector('[data-items]');
                    updatePaging(el, currentPage, resultsWrapperNew.dataset.totalPages);
                });
        }
    };

    return {
        initBlock
    };
})();
ControlBinders.register(`.patient-stories-block`, el => patientStories.initBlock(el));